export const environment = {
    production: false,
    environment: 'development',
    apiUrl: 'https://rigoplan-develop-api.fraenkische.com/api/',
    apiUrlClean: 'https://rigoplan-develop-api.fraenkische.com'
};

